import SectionSlider4 from "../../sections/home/index4/section-slider4"
import SectionServices1 from "../../sections/home/index4/section-services1"
import SectionWhyChooseUs2 from "../../sections/home/index4/section-why-choose-us2"
import SectionCompanyApproch1 from "../../sections/home/index4/section-company-approch1"
import SectionProjects2 from "../../sections/home/index4/section-projects2"
import { useEffect } from "react";
import { loadScript } from "../../../globals/constants"

import { useLangagesStore } from "../../../context/langages";
import { data as dataEN } from "../../../globals/data/en/home";
import { data as dataES } from "../../../globals/data/es/home";
import { data as dataCN } from "../../../globals/data/zh/home";
import SectionClients3 from "../../sections/home/index4/section-clients3"

function Home4Page() {

    const language = useLangagesStore((state) => state.langage);
    const data = language === "en" ? dataEN : language === "cn" ? dataCN : dataES;

    useEffect(() => {
        loadScript("/assets/js/custom.js", true)
    }, [])

    return (
        <>
            <SectionSlider4 _data={data.slide} />
            <SectionServices1 _data={data.services} />
            <SectionClients3 _data={data.clients} />
            <SectionWhyChooseUs2 _data={data.whychoosus} />
            <SectionCompanyApproch1 _data={data.approach} />
            <SectionProjects2 _data={data.projects} />
        </>
    )
}

export default Home4Page;